import { Box } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';

import { IDataGrid } from '../../../../interfaces/datagrid.interface';

const DynamicDataGrid = ({ columns, rows, config, onPagination }: IDataGrid) => {
  const setPageSetup = (page: number) => {
    if (onPagination) onPagination(page);
  };

  return (
    <Box sx={{ height: '100%' }}>
      {rows.length > 0 ? (
        config ? (
          <DataGrid
            getRowId={(rows) => rows.slug}
            rows={rows}
            columns={columns}
            pagination
            paginationMode='server'
            page={config.currentPage - 1}
            pageSize={config.count}
            rowsPerPageOptions={[10]}
            rowCount={config.total}
            onPageChange={(e) => {
              setPageSetup(e);
            }}
          />
        ) : (
          <DataGrid getRowId={(rows) => rows.slug} rows={rows} columns={columns} />
        )
      ) : (
        <Box
          sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          No Data Found
        </Box>
      )}
    </Box>
  );
};

export default DynamicDataGrid;
